import React, {useContext} from "react";
import { observer } from "mobx-react-lite";
import { Dimmer, Loader } from "semantic-ui-react";


import { RootStoreContext } from "../stores/rootStore";
import NavBar from "../../features/nav/NavBar";



const ForLoggedUsers = ({children}) => {
  const rootStore = useContext(RootStoreContext);
  const { isLoggedIn, relogUsers } = rootStore.userStore;

  if (!isLoggedIn) {
    relogUsers()
    return (
      <Dimmer active>
        <Loader content="Loading..." size="massive" />
      </Dimmer>
    );
  }

  return (
    <>
      <NavBar />
      {children}
    </>
  );
};

export default observer(ForLoggedUsers);
